import { Component, OnInit, ViewChild, AfterViewInit, QueryList, ViewChildren } from "@angular/core";
import { FacturacionClass } from "./facturacion.class";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2/dist/sweetalert2";
import { DataSpanidhDatatable } from "src/app/admin/admin.class";
import { Subject } from "rxjs/Subject";
import { DataTableDirective } from "angular-datatables";
import { NgxSpinnerService } from "ngx-spinner";
import * as XLSX from 'xlsx';
import { FacturacionesService } from "@app/services/facturacion.service";
import { AlmacenesService } from "@app/services/almacenes.service";
import { AuthService } from "@app/services/auth.service";
import { APP } from "./../../../constants";
declare var $: any;

@Component({
  selector: "app-importacion-facturas-masivas",
  templateUrl: "./importacion-facturas-masivas.component.html",
  styleUrls: ['./importacion-facturas-masivas.scss']
})
export class ImportacionFacturasMasivasComponent implements OnInit, AfterViewInit {
  @ViewChildren(DataTableDirective) dtElements: QueryList<DataTableDirective>;
  dtOptions: DataTables.Settings = {};
  dtTriggerFI: Subject<any> = new Subject();
  dtTriggerFG: Subject<any> = new Subject();

  almacenesListado: any = [];
  resolucionesListado: any = [];
  fecha_hoy: any = null;

  factura: FacturacionClass;
  excelData: any[] = [];
  facturasData: any[] = [];
  numFacturaLoop = 0;
  cantFacturasPorLote = 10;
  isRunningLoop = false;
  strMsgErrorSelected = null;
  urlViewDocumentoDian = APP.urlViewDocumentoDian;

  dataUsuario = null;

  constructor(
    private _SedeService: AlmacenesService,
    private _FacturacionesService: FacturacionesService,
    private _AuthService: AuthService,
    private toastr: ToastrService,
    private spinnerService: NgxSpinnerService,
  ) {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 50,
      language: DataSpanidhDatatable,
    };
    this.factura = new FacturacionClass();
  }

  ngOnInit() {
    this.cargarDataUsuario();
    this.dateOnChange();
  }

  ngAfterViewInit(): void {
    this.dtTriggerFI.next();
    this.dtTriggerFG.next();
  }

  async cargarDataUsuario() {
    this._AuthService.cargarDataUsuario({}, (data) => {
      this.dataUsuario = data.decodeToken.sub;
      this.factura.codusu = this.dataUsuario.id.toString();
      this.getAlmacenes();
    });
  }

  async getAlmacenes(user?: any) {
    await this._SedeService.listarAlmacenes(
      {
        id_empresa: this.dataUsuario.id_empresa,
        id_user: this.factura.codusu,
        accion: "U",
      },
      (data: { filas: { recordsets: any[] } }) => {
        this.almacenesListado = data.filas.recordsets[0];
      }
    );
  }

  async getResoluciones() {
    await this._FacturacionesService.resolucion(
      {
        id_empresa: this.dataUsuario.id_empresa,
        codalm: this.factura.codalm,
        accion: "L",
      },
      (result: { filas: { recordset: { consecutivo: any }[] } }) => {
        if (result.filas.recordset[0]) {
          let data = result["filas"]["recordsets"][0];
          data.map(e=>e.nombre = e.resolucion+" - "+e.Prefijo);
          this.resolucionesListado = data;
        } else {
          this.toastr.error(
            "Verifique la resolucion de la dian del almacen",
            "Error de consecutivo"
          );
        }
      }
    );
  }

  async getFacturasGuardadas() {
    if(this.factura.codalm == null || this.factura.feccom == null) return false;

    await this._FacturacionesService.listarFacturacionesGuardadas(
      {
        id_empresa: this.dataUsuario.id_empresa,
        codalm: this.factura.codalm,
        fecha: this.factura.feccom,
      },
      (result) => {
        if (result.status) {
          let data = result["filas"]["recordsets"][0];
          this.facturasData = [];
          let temp = [];
          data.forEach((e, i) => {
            let obj = {
              "No": (i+1),
              "CC": e.codter.toString().split("-")[0],
              "DIGITO": e.codter.toString().split("-")[1],
              "NOMBRES": e.nomter,
              "APELLIDOS": "",
              "CODIGO PRODUCTO": e.codins,
              "DESCRIPCION PRODUCTO": e.nomins,
              "cantidad": e.cantidad,
              "VALOR": e.valor,
              dataResponse: {
                item_num: (i+1),
                guardado: 1,
                enviado: e.enviado,
                data: {
                  numcom: e.numcom, 
                  id_factura: e.id_factura, 
                }
              }
            };
            if(e.enviado == 1){
              obj.dataResponse.data["uuid"] = e.uuid;
            }else{
              obj.dataResponse.data["error"] = "Porfavor reenviar la factura...";
            }
            temp.push(obj);
          });
          this.facturasData = temp;
          this.rerenderTable();
        } else {
          this.toastr.error("Error al consultar las facturas");
        }
      }
    );
  }

  changedFactura(event) {
    if (event) {
      this.factura.codalm = event.codalm;
      this.getResoluciones();
      this.getFacturasGuardadas();
    }
  }

  rerenderTable(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      if(dtElement.dtInstance){
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      }
    });
    this.dtTriggerFI.next(); 
    this.dtTriggerFG.next();    
  }

  dateOnChange() {
    let f = new Date();
    var fecha1 = new Date(f.getFullYear(), f.getMonth(), f.getDate());
    let dia: any =
      fecha1.getDate() > 9 ? fecha1.getDate() : "0" + fecha1.getDate();
    let dia2: any =
      fecha1.getDate() + 1 > 9
        ? fecha1.getDate() + 1
        : "0" + (fecha1.getDate() + 1);
    let mes: any =
      fecha1.getMonth() + 1 > 9
        ? fecha1.getMonth() + 1
        : "0" + (fecha1.getMonth() + 1);
    let año: any = fecha1.getFullYear();
    this.fecha_hoy = año + "-" + mes + "-" + dia;
    dia2 = dia2 - 1;
    this.factura.feccom = año + "-" + mes + "-" + dia;
    return this.fecha_hoy;
  }

  onFileChange(event: any) {
    this.spinnerService.show();

    const file = event.target.files[0];
    event.target.value = null;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      this.excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.excelData.map(e=>e.dataResponse = {});
      this.numFacturaLoop = 0;
      this.rerenderTable();
      this.spinnerService.hide();
    };
    reader.readAsBinaryString(file);
  }

  quitarItem(i: number) {
    this.excelData.splice(i, 1);
  }

  verDetalleError(i: number, tipo){
    let error = (tipo == "FI"?this.excelData[i].dataResponse.data.error:this.facturasData[i].dataResponse.data.error);
    this.strMsgErrorSelected = error;
    $("#modal-detalle-error").modal();
  }

  reenviarFactura(i: number, tipo){
    let id_factura = (tipo == "FI"?this.excelData[i].dataResponse.data.id_factura:this.facturasData[i].dataResponse.data.id_factura);
    Swal.fire({
      title: "¡Aviso!",
      text: "¿Seguro desea reenviar la factura N°"+id_factura+" a la Dian?",
      type: "info",
      showCancelButton: true,
      confirmButtonText: "Sí, Enviar",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.value) { 
          this.reenviarFacturaE(i, tipo, id_factura);
      }
    });
  }

  async guardar_factura() {
    Swal.fire({
      title: "¡Aviso!",
      text: "¿Seguro desea iniciar el envio de estas facturas?",
      type: "info",
      showCancelButton: true,
      confirmButtonText: "Sí, Guardar",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.value) { 
          this.isRunningLoop = true;  
          this.runLoopSendFacturas();
      }
    });
  }

  async cancelar_loop() {
    this.isRunningLoop = false;
    this.rerenderTable();
    this.getFacturasGuardadas();
  }

  runLoopSendFacturas(){
    let limitSlice = ((this.numFacturaLoop+this.cantFacturasPorLote) > this.excelData.length) ? this.excelData.length : (this.numFacturaLoop+this.cantFacturasPorLote);
    let dataExcel = [...this.excelData.slice(this.numFacturaLoop, limitSlice).map((value, index) => {
      return { ...value, item_num: (this.numFacturaLoop+index) };
    })];
    this.numFacturaLoop = limitSlice;

    let listFacturas = [];
    dataExcel.forEach(item => {
      let data = {...this.factura};

      data.item_num = item["item_num"];
      data.codter = item["CC"].toString() + "-" + item["DIGITO"].toString();
      data.nomter = item["NOMBRES"] + " " + item["APELLIDOS"];
      data.valorcom = item["VALOR"];
      data.cantidad = item["cantidad"];
      data.codins = item["CODIGO PRODUCTO"].toString();

      listFacturas.push(data);
    });

    if(this.numFacturaLoop <= this.excelData.length && listFacturas.length > 0) this.sendFacturas(listFacturas);
    else this.cancelar_loop();
  }

  sendFacturas(facturas) {
    try {
      this._FacturacionesService.guardarFacturaCompraMasivo({ id_empresa: this.dataUsuario.id_empresa, facturas }, async (result: any) => {
          if (result.status) {
            // ACTUALIZO LA TABLA CON LAS RESPUESTAS
            result.listFacturasResult.forEach(item => {
              this.excelData[item.item_num].dataResponse = item;
            });

            if(this.isRunningLoop) {
              setTimeout(() => {
                this.runLoopSendFacturas();
              }, 1000);
            }
          } else {
            this.cancelar_loop();
            this.toastr.error(result.filas.recordset[0].Message, "Error");
          }
        }
      );
    } catch (error) {
      this.cancelar_loop();
      this.toastr.error(error, "Error");
    }
  }

  reenviarFacturaE(index, tipo, id_factura) {
    try {
      this._FacturacionesService.generarFactura({ id_empresa: this.dataUsuario.id_empresa, id: id_factura }, async (result: any) => {
          if (result.status) {
            this.toastr.info(result.mensaje, "Resultados envio de factura");
            let obj = (tipo == "FI"?this.excelData[index]:this.facturasData[index]);
            if(result.filas[0][0].isValid){
              obj.dataResponse.enviado = 1;
              delete obj.dataResponse.data.error;
              obj.dataResponse.data.uuid = result.filas[0][0].uuid;
            }else{
              obj.dataResponse.enviado = 0;
              obj.dataResponse.data.error = result.filas[0][0].message;
              delete obj.dataResponse.data.uuid;
            }
            if(tipo == "FI") this.excelData[index] = obj;
            else this.facturasData[index] = obj;
          } else {
            this.toastr.error("Error", "Error");
          }
        }
      );
    } catch (error) {
      this.toastr.error(error, "Error");
    }
  }
  
  getObjectLength(obj: any): number {
    return Object.keys(obj).length;
  }

  getTotalFacturasGuardadas(){
    return this.excelData.filter(e=>e.dataResponse["guardado"] == 1).length || 0;
  }

  getTotalFacturasEnviadas(){
    return this.excelData.filter(e=>e.dataResponse["enviado"] == 1).length || 0;
  }

  getTotalFacturasRestantes(){
    return this.excelData.filter(e=>this.getObjectLength(e.dataResponse) == 0).length || 0;
  }

}
